import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './wrike-folder.types';
import * as constants from './wrike-folder.constants';

export const storeWrikeFolder = generateStoreResourceAction<types.IWrikeFolder>(constants.STORE_WRIKE_FOLDER);
export const clearWrikeFolder = generateClearResourceAction(constants.CLEAR_WRIKE_FOLDER);
